module.exports = __webpack_public_path__ + "img/d7d2dd7.jpg";